export const ActionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT:"SELECTED_PRODUCT",
    REMOVE_SELECTED_PRODUCT:"REMOVE_SELECTED_PRODUCT",
    ADD_USERS: "ADD_USERS",
    SINGLE_USER: "SINGLE_USER",
    REMOVE_SELECTED_USER:"REMOVE_SELECTED_USER"
}